import { styled } from 'styled-components';
import { TextBold, TextMedium } from '../../styles/GlobalStyledComponents';
import checkedOptionSVG from '../../assets/icons/optionCheckedRed.svg';
import { colors } from '../../styles/Colors';

interface OptionContainerProps {
  $isSelected?: boolean;
  $isRecommended?: boolean;
}

export const OptionContainer = styled.div<OptionContainerProps>`
  display: flex;
  background: ${(props) => (props.$isSelected ? colors.gray12 : 'inherit')};
  border: 1px solid
    ${(props) =>
      props.$isSelected
        ? colors.red7
        : props.$isRecommended
          ? colors.orange9
          : colors.gray11};
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
`;

export const OptionSection = styled.div`
  display: flex;
`;

export const RadioButtonSection = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 8px;
`;

export const RadioButton = styled.input`
  appearance: none;
  width: 22px;
  height: 22px;
  border: 2px solid ${colors.gray10};
  border-radius: 50%;
  margin-right: 6px;
  cursor: pointer;

  &:checked {
    background-image: url("${checkedOptionSVG}");
    background-repeat: no-repeat;
    background-position: center center;
  }
`;

export const LabelButton = styled.label``;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const OptionTitle = styled(TextBold)``;

export const OptionSubtitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
`;

export const OptionSubtitleSVG = styled.img``;

export const OptionSubtitleText = styled(TextMedium)`
  font-weight: 400;
`;

export const OptionDescription = styled(TextMedium)``;
